module.exports = __webpack_public_path__ + "img/progress-icon.35baff9.png";